var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.viewport.noninteractive",
          value: {
            title: _vm.text,
            disabled: !(_vm.icon || _vm.svg),
          },
          expression: "{\n    title: text,\n    disabled: !(icon || svg)\n  }",
          modifiers: { hover: true, viewport: true, noninteractive: true },
        },
      ],
      class: { "custom-group-action": _vm.isSvgButton },
      attrs: { variant: _vm.isSvgButton ? null : "primary" },
      on: { click: _vm.toggleSelection },
    },
    [
      _vm.icon
        ? _c("img", {
            attrs: { src: "/img/icons/select-all.svg", alt: "select-all-icon" },
          })
        : _vm.svg
        ? _c(
            "svg",
            {
              staticClass:
                "lucide lucide-grid2x2-check-icon lucide-grid-2x2-check",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
                },
              }),
              _vm._v(" "),
              _c("path", { attrs: { d: "m16 19 2 2 4-4" } }),
            ]
          )
        : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }